import toast from "react-hot-toast";

class RoleAPIs {
    static async list({ axiosPrivate, limit = 20, offset = 0 }) {
        try {
            const params = new URLSearchParams({
                ...(limit != null && { limit }),
                ...(offset != null && { offset }),
            });
            const q = params.toString();
            const url = q ? `/api/v1/agency/roles/?${q}` : `/api/v1/agency/roles/`;
            const response = await axiosPrivate.get(url);
            const list = response?.data?.data ?? response?.data ?? [];
            const count = response?.data?.count ?? list?.length ?? 0;
            return { data: Array.isArray(list) ? list : [], count };
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            return { data: [], count: 0 };
        }
    }

    static async create({ axiosPrivate, payload }) {
        try {
            const url = `/api/v1/agency/roles/`;
            const response = await axiosPrivate.post(url, payload);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async update({ axiosPrivate, id, payload }) {
        try {
            const url = `/api/v1/agency/roles/${id}/`;
            const response = await axiosPrivate.patch(url, payload);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async delete({ axiosPrivate, id }) {
        try {
            const url = `/api/v1/agency/roles/${id}/`;
            const response = await axiosPrivate.delete(url);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async listPermissions({ axiosPrivate, limit = 20, offset = 0 }) {
        try {
            const params = new URLSearchParams({
                ...(limit != null && { limit }),
                ...(offset != null && { offset }),
            });
            const q = params.toString();
            const url = q ? `/api/v1/agency/permissions/?${q}` : `/api/v1/agency/permissions/`;
            const response = await axiosPrivate.get(url);
            const list = response?.data?.data ?? response?.data ?? [];
            const count = response?.data?.count ?? list?.length ?? 0;
            return { data: Array.isArray(list) ? list : [], count };
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            return { data: [], count: 0 };
        }
    }

    static async createPermission({ axiosPrivate, payload }) {
        try {
            const url = `/api/v1/agency/permissions/`;
            const response = await axiosPrivate.post(url, payload);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }
}

export default RoleAPIs;
